// extracted by mini-css-extract-plugin
export default {"overlay":"It-z","bodyOpen":"Jt-z","content":"Kt-z","header":"Lt-z","close":"Mt-z","closeNoHeading":"Nt-z"};